import { render, staticRenderFns } from "./deanInputFileDragDrop.vue?vue&type=template&id=28360528&scoped=true"
import script from "./deanInputFileDragDrop.vue?vue&type=script&lang=ts"
export * from "./deanInputFileDragDrop.vue?vue&type=script&lang=ts"
import style0 from "./deanInputFileDragDrop.vue?vue&type=style&index=0&id=28360528&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28360528",
  null
  
)

export default component.exports